import * as z from "zod";
import { salesChannelSchema } from "./sales-channel";

export const getRedoSalesChannels = {
  name: "getRedoSalesChannels" as const,
  input: z.object({}),
  output: z.object({
    redoSalesChannels: z.array(salesChannelSchema).nullable(),
  }),
};
